import axios from "axios";
import { $notify } from "@/toaster/ToasterPlugin";

const endpoint = "owner/employee";
export default {
  // get coops
  async fetchEmployees({ commit, state }) {
    let response;
    try {
      response = await axios.get(state.next_employees_url);
      commit("SET_SUCCESS", true);
      if (state.shouldAppend) {
        commit("SET_EMPLOYEES", [...state.employees, ...response.data.data]);
      } else {
        commit("SET_EMPLOYEES", response.data.data);
      }
      commit("SET_NEXT_EMPLOYEES_URL", response.data.links.next);
      commit("SET_SHOULD_APPEND", true);
    } catch (e) {
      commit("SET_SUCCESS", false);
      commit("SET_ERRORS", e.response.data.errors ?? {});
      commit("SET_NEXT_EMPLOYEES_URL", undefined);
      $notify.apiError(e);
    }
  },
  async deleteEmployee({ commit, state }, { employeeId }) {
    try {
      await axios.delete(`owner/employee/${employeeId}`);
      commit("SET_SUCCESS", true);
      commit(
        "SET_EMPLOYEES",
        state.employees.filter((employee) => {
          return employee.id != employeeId;
        })
      );
    } catch (e) {
      commit("SET_SUCCESS", false);
      commit("SET_ERRORS", e.response.data.errors ?? {});
      $notify.error(e.response?.data);
    }
  },
  searchEmployee({ commit }, { keywords, station }) {
    commit(
      "SET_NEXT_EMPLOYEES_URL",
      endpoint + "?keywords=" + keywords + "&station_id=" + (station?.id ?? "")
    );
    commit("SET_SEARCH_STATION", station);
    commit("SET_SEARCH_KEYWORD", keywords);
    commit("SET_EMPLOYEES", []);
    commit("SET_SHOULD_APPEND", false);
  },
  async fetchEmployeeInfo(context, employeeId) {
    return (await axios.get(`owner/employee/${employeeId}`)).data.data;
  },
  async storeEmployee({ commit, state }, data) {
    let response;
    try {
      response = await axios.post(`${endpoint}`, data);
      let employee = response.data.data;
      commit("SET_SUCCESS", true);
      commit("SET_EMPLOYEES", [employee, ...state.employees]);
      commit("SET_ERRORS", {});
      return employee;
    } catch (e) {
      commit("SET_ERRORS", e.response.data.errors ?? {});
      commit("SET_SUCCESS", false);
    }
  },
  async updateEmployee({ commit, state }, { data, id }) {
    let response;
    try {
      response = await axios.post(`${endpoint}/${id}/update`, data);
      let updatedEmployee = response.data.data;
      commit("SET_SUCCESS", true);
      commit(
        "SET_EMPLOYEES",
        state.employees.map((employee) => {
          return employee.id == updatedEmployee.id ? updatedEmployee : employee;
        })
      );
      commit("SET_ERRORS", {});
      return updatedEmployee;
    } catch (e) {
      commit("SET_ERRORS", e.response.data.errors ?? {});
      commit("SET_SUCCESS", false);
    }
  },
};
